"use strict";

class DeveloperPermissionsController {

    constructor($scope, $timeout, SSHttpService, SSUtilService, SSDateService, SSAppService, SSAlertService, SSUserService, SSConfigService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.role_id = self.data.role_id;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.current_role = null;
        self.parent_role = null;
        self.showRolePermissionEdit = false;
        self.property = null;
        self.roles = null;

        self.user = self.SSUserService.getUser();

        self.grouped_dev_role_permissions_data = {};
        self.grouped_dev_all_permissions_data = {};

        self.filter_permissions = '';

        self.dev_level_perms = null;
        self.prop_level_perms = null;
        self.prepareDeveloperProperties();
        self.permissions_idz = [];
        self.getRolesData();

    }

    getRolesData() {
        const self = this;

        self.role_permissions = [];
        self.current_role_permissions = [];
        self.role_permissions_data = {};

        self.permissions = [];

        //let url = 'sec/developer/roles';
        //let url = 'sec/developer/' + self.user.id + '/roles/'+ self.role_id +'/role-permissions';
        let url = 'sec/developer/roles/' + self.role_id + '/role-permissions';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.response_data = response.data;
            self.all_permissions = self.response_data.permissions;
            //self.parent_role                = self.response_data.developer_roles[self.current_role.parent_role_id];
            //self.current_role_permissions  = self.response_data.role_permission[self.role_id];
            //self.current_role               = self.response_data.developer_roles[current_role];
            self.current_role = self.response_data.developer_roles['current_role'];
            self.current_role_permissions = self.response_data.role_permission['current_permissions'];
            self.parent_role = self.response_data.developer_roles['creator_role'];
            self.parent_role_permissions = self.response_data.role_permission['creator_permissions'];


            self.updateFilter(self.property);


            //if(!self.property){
            //    // In detfault only list the permissions assigned by super admin to developer
            //    self.dev_level_perms  = self.filterPermissions(self.current_role_permissions,self.permissions,false);//get permission above property level\
            //    self.role_permissions =  self.dev_level_perms;
            //
            //}
            //else{
            //
            //    self.prop_level_perms = self.filterPermissions(self.current_role_permissions,self.permissions,true);//get permission property level\
            //    self.role_permissions =  self.prop_level_perms;
            //
            //
            //}
            //$.each(self.role_permissions, function (index, permission) {
            //    self.permissions_idz.push(permission.id);
            //});

            //var userPermissionsLocal = self.SSUserService.getUserPermissions();
            //
            //
            //if(self.roles && userPermissionsLocal){
            //    let rolePermissions = self.SSUserService.getRolePermissions();
            //
            //    // $.each(self.roles, function(i, role){
            //    //     if(role.permissions && role.permissions.length == response.data.permissions.length){
            //    //         rolePermissions = role.permissions;
            //    //         return false;
            //    //     }
            //    // });
            //
            //    if(rolePermissions){
            //        self.permissions = self.getFormattedPermissions(userPermissionsLocal, rolePermissions);
            //    }

            //}
            //
            //self.all_permissions = self.permissions;
            //
            //self.current_role = self.roles.find(x => x.id == self.role_id);
            //
            //// self.current_role_permissions = {};
            //// if(self.current_role.permissions){
            ////     $.each(self.current_role.permissions, function(index, permission){
            ////         self.current_role_permissions[permission.permission_id] = permission;
            ////     });
            //// }
            //
            //// Get all permissions against this role
            //if(self.current_role){
            //    $.each(self.current_role.permissions, function(index, permission){
            //        let _permission = self.all_permissions.find(x => x.id == permission.permission_id);
            //
            //        if(_permission && !self.role_permissions.find(x => x.id == permission.permission_id)){
            //            self.role_permissions.push(_permission);
            //        }
            //    });
            //}
            //
            //self.$timeout(function() {
            //    self.removeDumplicateValues(self.role_permissions);
            //});
            //
            //// Get property and dev level permissions from local storage
            //self.propertyLevelPermissions = self.getPropertyLevelPermissions(self.permissions);
            //self.devLevelPermissions = self.getDevLevelPermissions(self.permissions);
            //
            //self.role_permissions_data = {
            //    role_permissions : self.permissions,
            //    role : self.current_role,
            //}
            //
            //self.updateFilter(self.property);
        });
    }

    getFormattedPermissionsNew(rolePermissions, allPermissions) {

        const self = this;

        let permissions = [];

        if (allPermissions && rolePermissions) {
            $.each(rolePermissions, function (index, permission) {
                // let _permission = userPermissions.find(x => x.id == permission.permission_id);
                let _permission = self.getPermissionById(allPermissions, permission.permission_id);
                if (_permission) {
                    if (permissions.indexOf(_permission) === -1) {
                        permissions.push(_permission);
                    }
                }
            });
        }
        return permissions;


    }

    removeDumplicateValues(array) {
        var _array = [];
        $.each(array, function (key, value) {
            var exists = false;
            $.each(_array, function (k, val2) {
                if (value.id == val2.id) {
                    exists = true;
                    console.log('WARNING: Duplicate data received from server.');
                    console.log(value);
                }
            });
            if (exists == false && value.id != "") {
                _array.push(value);
            }
        });

        return _array;
    }

    getPropertyLevelPermissions(rolePermissions) {
        const self = this;
        let permissions = [];

        if (rolePermissions) {
            $.each(rolePermissions, function (index, permission) {
                //if(permission.property_ids){
                if (permission && permission.property_level) {
                    permissions.push(permission);
                }
            });
        }
        return permissions;
    }

    getDevLevelPermissions(rolePermissions) {
        const self = this;
        let permissions = [];

        if (rolePermissions) {
            $.each(rolePermissions, function (index, permission) {
                //if(permission.property_ids){
                if (permission && !permission.property_level) {
                    permissions.push(permission);
                }
            });
        }
        return permissions;
    }

    filterPermissions(rolePermissions, permissions, propertyLevel) {
        const self = this;
        let _permissions = [];
        self.grouped_dev_all_permissions_data = {};
        if (rolePermissions) {
            $.each(rolePermissions, function (index, perms) {
                //$.each(perms, function (_index, _perm) {
                //    if(index == perms.role_id){
                let _perm = self.getPermissionById(permissions, perms.permission_id);
                if (_perm && _perm.property_level == propertyLevel) {
                    _permissions.push(_perm);
                }
            });
        }

        for(var i in _permissions)
        {
            self.grouped_dev_all_permissions_data.hasOwnProperty(_permissions[i].group) ?
                self.grouped_dev_all_permissions_data[_permissions[i].group].push(_permissions[i]) :
                (self.grouped_dev_all_permissions_data[_permissions[i].group] = [_permissions[i]]);
        }


        return _permissions;
    }

//    getFormattedPermissions(userPermissions, rolePermissions){
//        const self = this;
//return;
//        let permissions = [];
//
//        if(userPermissions && rolePermissions){
//            $.each(rolePermissions, function(index, permission){
//
//                // let _permission = userPermissions.find(x => x.id == permission.permission_id);
//                let _permission = self.getPermissionById(userPermissions, permission.permission_id);
//                if(_permission){
//                    _permission.property_ids = permission.property_ids;
//                    _permission.role_id = permission.role_id;
//                    if(permissions.indexOf(_permission) === -1){
//
//                        permissions.push(_permission);
//                    }
//                }
//            });
//        }
//        return permissions;
//    }

    getPermissionById(permissions, permission_id) {
        const self = this;

        let permission = null;
        $.each(permissions, function (i, _permission) {
            if (_permission.id == permission_id) {
                permission = _permission;
                return false;
            }

        });

        return permission;
    }

    //updateFilter(property){
    //    const self = this;
    //
    //    if(self.current_role){
    //        self.role_permissions = [];
    //        if(property){
    //            $.each(self.current_role.permissions, function(index, permission){
    //                let property_ids = permission.property_ids.split(',');
    //                if($.inArray((property.id).toString(), property_ids) > -1){
    //                    let _permission = self.permissions.find(x => x.id == permission.permission_id);
    //                    if(_permission){
    //                        self.role_permissions.push(_permission);
    //                    }
    //                }
    //            });
    //        }
    //        else{
    //            $.each(self.current_role.permissions, function(index, permission){
    //                if(!permission.property_ids){
    //                    let _permission = self.permissions.find(x => x.id == permission.permission_id);
    //                    if(_permission){
    //                        self.role_permissions.push(_permission);
    //                    }
    //                }
    //            });
    //        }
    //
    //        self.$timeout(function() {
    //            self.role_permissions_data = {
    //                role_permissions : self.role_permissions,
    //                role : self.current_role,
    //            }
    //        });
    //    }
    //}
    updateFilter(property) { //used in dropdown

        const self = this;
        //self.permissions = self.response_data.permissions;self.user
        let _perms = self.parent_role_permissions;
        self.permissions=[];
        self.grouped_dev_role_permissions_data = {};

        $.each(_perms, function(i, p) {
            let _permission = self.all_permissions.find(x => x.id == p.permission_id);
            if (_permission) {
                self.permissions.push(_permission);
            }
        });

        self.property = property;
        self.role_permissions = [];
        self.permissions_idz = [];
        if (!self.property) {
            self.grouped_dev_role_permissions_data = {};
            self.dev_level_perms = self.filterPermissions(self.current_role_permissions, self.permissions, false);//get permission above property level\
            self.role_permissions = self.dev_level_perms;
            $.each(self.role_permissions, function (index, permission) {
                self.permissions_idz.push(permission.id);
            });

            for(var i in self.role_permissions)
            {
                self.grouped_dev_role_permissions_data.hasOwnProperty(self.role_permissions[i].group) ?
                    self.grouped_dev_role_permissions_data[self.role_permissions[i].group].push(self.role_permissions[i]) :
                    (self.grouped_dev_role_permissions_data[self.role_permissions[i].group] = [self.role_permissions[i]]);
            }
        }
        else {
            self.grouped_dev_role_permissions_data = {};
            self.prop_level_perms = self.filterPermissions(self.current_role_permissions, self.permissions, true);//get permission above property level\\
            console.log("Property Level Permissions Already assigned in updateFilter");
            console.log(self.prop_level_perms);
            $.each(self.current_role_permissions, function (i, perm) {
                //$.each(perm, function (index, permission) {
                let property_ids = perm.property_ids.split(',');
                if ($.inArray((property.id).toString(), property_ids) > -1) {
                    let _permission = self.prop_level_perms.find(x => x.id == perm.permission_id);
                    if (_permission) {
                        self.role_permissions.push(_permission);
                        self.permissions_idz.push(_permission.id);

                    }
                }
            });
            for(var i in self.role_permissions)
            {
                self.grouped_dev_role_permissions_data.hasOwnProperty(self.role_permissions[i].group) ?
                    self.grouped_dev_role_permissions_data[self.role_permissions[i].group].push(self.role_permissions[i]) :
                    (self.grouped_dev_role_permissions_data[self.role_permissions[i].group] = [self.role_permissions[i]]);
            }
        }
    }

    parentCheked(value) {

        const self = this;
        var counter = 0;
        $(value).each(function(index, permission){
            if(!self.findValueInArray(permission.id,self.permissions_idz))
            {
                counter = 1
            }
        });
        if(counter == 1)
            return false;
        return true;
    }

    findValueInArray(value,arr){
        for(var i=0; i<arr.length; i++){
            var name = arr[i];
            if(name == value){
                return true;
            }
        }
        return false;
    }

    toggleChangeset(id) {
        const self = this;

        let div = $("#divChangeset" + self.groupSpacehandle(id));

        if (div.is(":visible")) {
            div.slideUp(400);
        } else {
            div.slideDown(400);
        }
    }

    toggleChangeset2(id) {
            const self = this;

            let div2 = $("#divChangesett" + self.groupSpacehandle(id));

            if (div2.is(":visible")) {
                div2.slideUp(400);
            } else {
                div2.slideDown(400);
            }

            // div2.slideDown('slow', function () {
            //     cardHeader.find('i.fa-caret-left').removeClass('fa-caret-left').addClass('fa-caret-down');
            // });


        }
    /**
     * Build a CSS-safe DOM-id fragment from a permission-group name.
     *
     * The same fragment is used to (a) render each group panel's `id` attribute
     * in the Blade and (b) build the `$("#divChangeset" + fragment)` jQuery
     * selector in toggleChangeset()/toggleChangeset2(). Group names can contain
     * symbols that are illegal in an unescaped CSS identifier (notably `&`), and
     * passing such a string to Sizzle throws "unrecognized expression". Replacing
     * every non-alphanumeric character with `_` (the previous `id.replace(' ','_')`
     * only swapped the first space) keeps both sides in sync and guarantees a
     * valid selector.
     *
     * @param {string} id - Raw permission-group name (e.g. "Super Admin — Roles & Permissions").
     * @returns {string} CSS-safe id fragment (e.g. "Super_Admin___Roles___Permissions").
     */
    groupSpacehandle(id)
    {
        return String(id).replace(/[^A-Za-z0-9]/g, '_');
    }


    showChangeset(id) {
        const self = this;

        let div = $("#divChangeset" + self.groupSpacehandle(id));

        if (!div.is(":visible")) {
            div.slideDown(400);
        }
    }

    prepareDeveloperProperties() {
        const self = this;

        let url = 'sec/developer/properties';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;
            self.$timeout(function () {
                $("select.dashboard-select#property-select").niceSelect('update');
            });
        });
    }

    addRemovePermissions(entry, chk){
        const self = this;

        chk = event.target.checked;

        if(chk){
            if(self.permissions_idz.indexOf(entry) == -1)
                self.permissions_idz.push(entry);
        }
        if(!chk){
            if(self.permissions_idz.indexOf(entry) > -1)
                self.permissions_idz.splice($.inArray(entry, self.permissions_idz),1);
        }
    }

    editRolePermissions(property) {
        const self = this;

        self.filter_permissions = '';
        if (!self.property) {

            self.permissions = self.filterPermissions(self.parent_role_permissions, self.permissions, false);
        }
        else {
            self.permissions = self.filterPermissions(self.parent_role_permissions, self.permissions, true);
        }
        //self.clearFilter();
        //self.permissions_idz = [];
        //self.dev_level_perms = [];
        //self.role_permissions = [];
        //let permissions_idz = [];
        //
        //
        //if(!self.property){
        //    self.dev_level_perms  = self.filterPermissions(self.current_role_permissions,self.permissions,false);//get permission above property level\
        //    //For defualt only Dev level perms will be available
        //    self.permissions =  self.dev_level_perms;
        //}
        //else{
        //    //When property selected all permissions will be list.
        //    self.dev_level_perms  = self.filterPermissions(self.current_role_permissions,self.permissions,false);//get permission above property level\\
        //    self.role_permissions =  self.dev_level_perms; //For property level default permission automatically listed
        //
        //    //Filter Property Level Perms
        //    self.prop_level_perms = self.filterPermissions(self.current_role_permissions,self.permissions,true);//get permission property level\
        //    //Here "self.role_permissions" will contain all above property level and assigned property level permissions
        //    //again filter self.permissions_idz;
        //    $.each(self.role_permissions, function(i,permission){
        //            self.permissions_idz.push(permission.id);
        //    });
        //    self.permissions            = self.response_data.permissions;
        //}


        // If property is selected then show only those permissions which are at property level
        // If property is not selected then show developer level permissions (i.e permissions which are above property level)

        //let permissions = [];

        //self.role_permissions = self.permissions;

        //self.permissions = self.all_permissions;
        //if(self.property){
        //    permissions = self.getPropertyLevelPermissions(self.permissions);
        //}
        //else{

        //    permissions = self.getDevLevelPermissions(self.permissions);
        //}
        //self.role_permissions_data = {
        //    role_permissions : permissions,
        //    role : self.current_role,
        //}

        //self.permissions_idz = [];
        //self.permissions = permissions;

        // Following loop will 'check' the checkboxes on the basis of conditions below
        //if(self.property){
        //    $.each(self.role_permissions_data.role_permissions, function(index, permission){
        //        let _permission = self.current_role.permissions.find(x => x.permission_id == permission.id);
        //        if(_permission && _permission.property_ids){
        //            let property_ids = _permission.property_ids.split(",");
        //            if($.inArray(self.property.id.toString(), property_ids) > -1){
        //                self.permissions_idz.push(permission.id);
        //            }
        //        }
        //    });
        //}
        //else {
        //    let devLevelPermissions = self.getDevLevelPermissions(self.current_role.permissions);
        //    $.each(self.role_permissions_data.role_permissions, function(index, permission){
        //        if(devLevelPermissions.find(x => x.permission_id == permission.id)){
        //            self.permissions_idz.push(permission.id);
        //        }
        //    });
        //}


        $.each(self.grouped_dev_all_permissions_data, function (group, permissions) {

            let isPartial = true;
            let counter = 0;

            $(permissions).each(function(index, permission){
                if(self.findValueInArray(permission.id,self.permissions_idz))
                {
                    counter += 1;
                }
            });

            if(counter == permissions['length'])
            {
                isPartial = false;
            }
            else if (counter == 0){

                isPartial = false;
            }

            if (isPartial) {
                self.showChangeset(group);
            }

        });



        self.showRolePermissionEdit = true;
    }

    //updateRolePermissions(){
    //    const self = this;
    //
    //    let confirmMsg = 'update';
    //    if(self.role_permissions_data.role_permissions && self.role_permissions_data.role_permissions.length == 0){
    //        confirmMsg = 'add'
    //    }
    //    self.SSConfirmationService.getConfirmed(
    //        'Confirm!',
    //        'Are you sure you want to '+ confirmMsg +' permission(s)?',
    //        self.SSConfirmationService.TYPE_DEFAULT,
    //        function () {
    //            //let permissions_idz = [];
    //            let permissions = [];
    //            //$("input[name='child[]']:checked:not(:disabled)").each(function ()
    //            //{
    //            //    permissions_idz.push(parseInt($(this).val()));
    //            //});
    //
    //            //debugger;
    //            if(self.property){
    //                if(self.permissions_idz && self.permissions_idz.length > 0){
    //                //if(permissions_idz && permissions_idz.length > 0){
    //                    $.each(self.permissions_idz, function(index, id){
    //                    //$.each(permissions_idz, function(index, id){
    //                        let _permission = self.current_role.permissions.find(x => x.permission_id == id);
    //
    //                        let property_ids = self.property.id.toString();
    //                        if(_permission && _permission.property_ids){
    //                            property_ids = property_ids + "," + _permission.property_ids;
    //                            property_ids = self.getUniqueValues(property_ids);
    //                        }
    //
    //                        // permissions.push({permission_id: id, property_ids: property_ids});
    //                        if(!permissions.find(x => x.permission_id == id)){
    //                            permissions.push({permission_id: id, property_ids: property_ids});
    //                        }
    //                    });
    //
    //                    let propertyLevelPermissions = self.getPropertyLevelPermissions(self.current_role.permissions);
    //
    //                    // Remove current property_id from previous permissions if exist
    //                    $.each(propertyLevelPermissions, function(index, permission){
    //
    //                        // If 'check box' is not checked then push previous permission to updated permissions
    //                        //if($.inArray(permission.permission_id, self.permissions_idz) == -1){
    //                        if($.inArray(permission.permission_id, permissions_idz) == -1){
    //
    //                            let property_ids = permission.property_ids.split(",");
    //                            // If following condition is false then 'property_ids' is an array
    //                            if($.inArray(self.property.id.toString(), property_ids) > -1){
    //                                property_ids.splice($.inArray(self.property.id.toString(), property_ids), 1);
    //                                property_ids = property_ids.join(",");
    //                            }
    //                            if(property_ids && !permissions.find(x => x.permission_id == permission.permission_id)){
    //                                permissions.push({permission_id: permission.permission_id, property_ids: property_ids.toString()});
    //                            }
    //                        }
    //                    });
    //                }
    //
    //                // Append Dev level permissions if already exist
    //                let rolePermissions = self.response_data.role_permission[self.current_role.id];
    //                if(rolePermissions){
    //                    //let devLevelPermissions = self.getDevLevelPermissions(rolePermissions);
    //                    let devLevelPermissions = self.dev_level_perms;
    //                    $.each(devLevelPermissions, function(i, permission){
    //                        if(!permissions.find(x => x.permission_id == permission.permission_id)){
    //                            permissions.push({permission_id: permission.permission_id, property_ids: permission.property_ids});
    //                        }
    //                    });
    //                }
    //            }
    //            else{
    //
    //                //if(self.permissions_idz && self.permissions_idz.length > 0){
    //                if(permissions_idz && permissions_idz.length > 0){
    //                    //$.each(self.permissions_idz, function(index, id){
    //                    $.each(permissions_idz, function(index, id){
    //                        if(!permissions.find(x => x.permission_id == id)){
    //                            permissions.push({permission_id: id, property_ids: ""});
    //                        }
    //                    });
    //                }
    //                 //Append Property level permissions if already exist
    //                let rolePermissions = self.response_data.role_permission[self.current_role.id];
    //                if(rolePermissions){
    //                    //let propertyLevelPermissions = self.getPropertyLevelPermissions(rolePermissions);
    //                    let propertyLevelPermissions = self.prop_level_perms;
    //                    $.each(propertyLevelPermissions, function(i, permission){
    //                        if(!permissions.find(x => x.permission_id == permission.permission_id)){
    //                            permissions.push({permission_id: permission.permission_id, property_ids: permission.property_ids});
    //                        }
    //                    });
    //                }
    //            }
    //
    //
    //
    //            let url = 'sec/developer/roles/' + self.current_role.id;
    //            let params = {
    //                name: self.current_role.name,
    //                display_name: self.current_role.display_name,
    //                description: self.current_role.description,
    //                permissions: permissions
    //            };
    //
    //            loading(true);
    //            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
    //                loading(false);
    //                if (response instanceof Error) {
    //                    self.SSAlertService.parseAndDisplayError(response);
    //                    return;
    //                }
    //
    //                // Get updated data
    //                self.getRolesData();
    //                self.clearFilter();
    //                //self.updateFilter(self.property);
    //                self.showRolePermissionEdit = false;
    //
    //                self.SSAlertService.success('Success!', 'Permissions updated successfully.');
    //
    //            });
    //        }
    //    );
    //}

    updateRolePermissions() {
        const self = this;

        //console.log('self.permissions_idz');
        //console.log(self.permissions_idz);

        // if(self.permissions_idz.length == 0){
        //     self.SSAlertService.danger('Error!', 'Please select at least one permission to proceed.');
        //     return;
        // }

        let confirmMsg = 'update';
        if (self.current_role_permissions && self.current_role_permissions.length == 0) {
            confirmMsg = 'add'
        }
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to ' + confirmMsg + ' permission(s)?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let permissions = [];

                if (self.property) {
                    if (self.permissions_idz && self.permissions_idz.length > 0) {

                        $.each(self.permissions_idz, function (index, id) {
                            let _permission = self.current_role_permissions.find(x => x.permission_id == id);
                            let property_ids = self.property.id.toString();
                            if (_permission && _permission.property_ids) {
                                property_ids = property_ids + "," + _permission.property_ids;
                                property_ids = self.getUniqueValues(property_ids);
                            }
                            // permissions.push({permission_id: id, property_ids: property_ids});
                            if (!permissions.find(x => x.permission_id == id)) {
                                permissions.push({permission_id: id, property_ids: property_ids});
                            }
                        });
                        console.log("Permission>>>es");
                        console.log(self.current_role_permissions);


                    }
                    let propertyLevelPermissions = self.prop_level_perms;
                    console.log("Property Level Permissions Already assigned in Update");
                    console.log(propertyLevelPermissions);
                    // Remove current property_id from previous permissions if exist
                    $.each(propertyLevelPermissions, function (index, permission) {

                        // If 'check box' is not checked then push previous permission to updated permissions
                        if ($.inArray(permission.id, self.permissions_idz) == -1) {

                            //let _permission = self.current_role.permissions.find(x => x.permission_id == permission.permission_id);
                            let _permission = self.current_role_permissions.find(x => x.permission_id == permission.id);
                            let property_id = self.property.id.toString();
                            let property_ids = _permission.property_ids.split(",");
                            // If following condition is false then 'property_ids' is an array
                            if ($.inArray(property_id, property_ids) > -1) {
                                property_ids.splice($.inArray(property_id, property_ids), 1);
                                property_ids = property_ids.join(",");
                            }
                            if (property_ids && !permissions.find(x => x.permission_id == permission.id)) {
                                permissions.push({permission_id: permission.id, property_ids: property_ids.toString()});
                            }
                        }
                    });

                    // Append Dev level permissions if already exist
                    //let rolePermissions = self.response_data.role_permission[self.current_role.id];
                    let rolePermissions = self.current_role_permissions;
                    if (rolePermissions) {
                        //let devLevelPermissions = self.getDevLevelPermissions(rolePermissions);
                        self.dev_level_perms = self.filterPermissions(rolePermissions, self.all_permissions, false);//get detail permission data above property level\
                        let devLevelPermissions = self.dev_level_perms;
                        $.each(devLevelPermissions, function (i, permission) {
                            if ($.inArray(permission.id, self.permissions_idz) == -1) {
                                //let _permission = self.current_role_permissions.find(x => x.permission_id == permission.id);
                                permissions.push({permission_id: permission.id, property_ids: ""});

                            }
                        });
                    }
                }
                else {

                    if (self.permissions_idz && self.permissions_idz.length > 0) {
                        $.each(self.permissions_idz, function (index, id) {
                            if (!permissions.find(x => x.permission_id == id) && typeof id !== "undefined") {
                                permissions.push({permission_id: id, property_ids: ""});
                            }
                        });
                    }

                    let rolePermissions = self.current_role_permissions;
                    // Append Property level permissions if already exist
                    if (rolePermissions) {
                        //let propertyLevelPermissions = self.getPropertyLevelPermissions(rolePermissions);
                        self.prop_level_perms = self.filterPermissions(rolePermissions, self.all_permissions, true);//get detail permission data property level
                        let propertyLevelPermissions = self.prop_level_perms;
                        $.each(propertyLevelPermissions, function (index, permission) {
                            // If 'check box' is not checked then push previous permission to updated permissions
                            if ($.inArray(permission.id, self.permissions_idz) == -1) {
                                let _permission = self.current_role_permissions.find(x => x.permission_id == permission.id);
                                //permissions.push(_permission);
                                if (!permissions.find(x => x.permission_id == permission.id)) {
                                    permissions.push({permission_id: permission.id, property_ids: _permission.property_ids});
                                }


                            }
                        });
                    }
                }

                console.log('permissions');
                console.log(permissions);

                let url = 'sec/developer/roles/' + self.current_role.id;
                //let url = 'sec/developer/' + self.user.id + '/roles/' + self.current_role.id;
                let params = {
                    name: self.current_role.name,
                    display_name: self.current_role.display_name,
                    description: self.current_role.description,
                    permissions: permissions
                };

                loading(true);
                self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.clearFilter();
                    self.showRolePermissionEdit = false;
                    self.SSAlertService.success('Success!', 'Permissions updated successfully.');

                    // Get updated data
                    self.getRolesData();
                });
            }
        );
    }

    getUniqueValues(property_ids) {
        const self = this;

        if (!property_ids) {
            return "";
        }

        let array = property_ids.split(",");

        let unique = array.filter(function (item, index, array) {
            return index == array.indexOf(item);
        });

        return unique.join(",");
    }

    toggleSelect(value,key) {
        const self = this;

        var check = $("input[name='"+key+"']").prop('checked');

        $(value).each(function(index, permission){

            self.addRemovePermissions(permission.id,check);
        })

    }
    // toggleSelect() {
    //     const self = this;
    //
    //     var check = $("input[name='parent']").prop('checked');
    //     $("input[name='child[]']:not(:disabled)").each(function () {
    //         var entry = JSON.parse($(this).prop('value'));
    //         $(this).prop('checked', check);
    //         self.addRemovePermissions(entry, check);
    //     })
    //
    // }

    filterPermission() {
        const self = this;
        let property_level = false;

        //let permissions = self.permissions;
        if(self.property){
            property_level = true;
        }
        let permissions = self.filterPermissions(self.parent_role_permissions,self.all_permissions,property_level) ;
        self.selected_permission = [];
        $.each(permissions, function (i, e) {
            var searchOn = e.name.toLowerCase();
            var search = self.filter_permissions.toLowerCase();
            if (searchOn.indexOf(search) > -1 && property_level == e.property_level) {
                self.selected_permission.push(e);
            }
        });

        self.permissions = self.selected_permission;

        console.log(self.permissions);
        self.grouped_dev_all_permissions_data = {};
        for(var i in self.permissions)
        {
            self.grouped_dev_all_permissions_data.hasOwnProperty(self.permissions[i].group) ?
                self.grouped_dev_all_permissions_data[self.permissions[i].group].push(self.permissions[i]) :
                (self.grouped_dev_all_permissions_data[self.permissions[i].group] = [self.permissions[i]]);
        }
    }

    clearFilter() {
        const self = this;
        //self.permissions = self.response_data.permissions;
        //self.permissions = ;
        let property_level = false;
        if(self.property){
            property_level = true;
        }
        self.permissions = self.filterPermissions(self.parent_role_permissions, self.all_permissions, property_level);
        //self.updateFilter(self.property);
        //if(!self.property) {
        //    self.permissions = self.getDevLevelPermissions(self.permissions);
        //}
        //else{
        //
        //    self.permissions = self.getPropertyLevelPermissions(self.permissions);
        //}
        //if (!self.property) {
        //    self.permissions = self.filterPermissions(self.parent_role_permissionss, self.permissions, false);
        //}
        //else {
        //    self.permissions = self.filterPermissions(self.parent_role_permissionss, self.permissions, true);
        //}
        self.filter_permissions = '';
    }

}

DeveloperPermissionsController.$inject = ['$scope', '$timeout', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAppService', 'SSAlertService', 'SSUserService', 'SSConfigService', 'SSConfirmationService'];
app.controller('DeveloperPermissionsController', DeveloperPermissionsController);


